import { motion } from 'framer-motion';
import { Brain, Clock, Heart, Shield, Smartphone, Zap } from 'lucide-react';
import { useLanguageStore } from '../store/languageStore';

const translations = {
  EN: {
    title: "Powerful Features for Emergency Response",
    subtitle: "Everything you need to handle emergencies with confidence and efficiency.",
    features: [
      {
        title: "AI-Powered Guidance",
        description: "Get intelligent, context-aware assistance during emergencies with our advanced AI system.",
  },
  {
        title: "Real-Time Response",
        description: "Receive immediate support and instructions when you need them most.",
  },
  {
        title: "Emergency Services Integration",
        description: "Seamlessly connect with emergency services and healthcare providers.",
  },
  {
        title: "Privacy-Focused",
        description: "Your data is encrypted and protected with enterprise-grade security.",
      },
      {
        title: "Cross-Platform",
        description: "Access RightNowAid on any device, anywhere, anytime.",
      },
      {
        title: "Lightning Fast",
        description: "Experience sub-second response times for critical information.",
      },
    ],
  },
  ES: {
    title: "Características Potentes para Respuesta a Emergencias",
    subtitle: "Todo lo que necesitas para manejar emergencias con confianza y eficiencia.",
    features: [
      {
        title: "Guía con IA",
        description: "Obtén asistencia inteligente y contextual durante emergencias con nuestro sistema de IA avanzado.",
      },
      {
        title: "Respuesta en Tiempo Real",
        description: "Recibe apoyo e instrucciones inmediatas cuando más las necesites.",
      },
      {
        title: "Integración con Servicios de Emergencia",
        description: "Conéctate sin problemas con servicios de emergencia y proveedores de salud.",
      },
      {
        title: "Enfocado en la Privacidad",
        description: "Tus datos están encriptados y protegidos con seguridad de nivel empresarial.",
      },
      {
        title: "Multiplataforma",
        description: "Accede a RightNowAid en cualquier dispositivo, en cualquier lugar y momento.",
      },
      {
        title: "Ultra Rápido",
        description: "Experimenta tiempos de respuesta sub-segundos para información crítica.",
      },
    ],
  },
  ZH: {
    title: "强大的紧急响应功能",
    subtitle: "处理紧急情况所需的一切，让您充满信心和效率。",
    features: [
      {
        title: "AI驱动的指导",
        description: "通过我们先进的AI系统，在紧急情况下获得智能、情境感知的协助。",
      },
      {
        title: "实时响应",
        description: "在您最需要的时候获得即时支持和指导。",
      },
      {
        title: "紧急服务集成",
        description: "无缝连接紧急服务和医疗保健提供者。",
  },
  {
        title: "注重隐私",
        description: "您的数据使用企业级安全进行加密和保护。",
      },
      {
        title: "跨平台",
        description: "随时随地通过任何设备访问RightNowAid。",
      },
      {
        title: "闪电般快速",
        description: "关键信息实现亚秒级响应时间。",
      },
    ],
  },
  VI: {
    title: "Tính Năng Mạnh Mẽ cho Ứng Phó Khẩn Cấp",
    subtitle: "Tất cả những gì bạn cần để xử lý tình huống khẩn cấp với sự tự tin và hiệu quả.",
    features: [
      {
        title: "Hướng Dẫn bằng AI",
        description: "Nhận hỗ trợ thông minh, nhận thức ngữ cảnh trong tình huống khẩn cấp với hệ thống AI tiên tiến của chúng tôi.",
      },
      {
        title: "Phản Hồi Thời Gian Thực",
        description: "Nhận hỗ trợ và hướng dẫn ngay lập tức khi bạn cần nhất.",
      },
      {
        title: "Tích Hợp Dịch Vụ Khẩn Cấp",
        description: "Kết nối liền mạch với dịch vụ khẩn cấp và nhà cung cấp y tế.",
      },
      {
        title: "Tập Trung vào Quyền Riêng Tư",
        description: "Dữ liệu của bạn được mã hóa và bảo vệ với bảo mật cấp doanh nghiệp.",
      },
      {
        title: "Đa Nền Tảng",
        description: "Truy cập RightNowAid trên mọi thiết bị, mọi nơi, mọi lúc.",
      },
      {
        title: "Siêu Nhanh",
        description: "Trải nghiệm thời gian phản hồi dưới một giây cho thông tin quan trọng.",
      },
    ],
  },
  FIL: {
    title: "Makapangyarihang Features para sa Emergency Response",
    subtitle: "Lahat ng kailangan mo para sa paghawak ng mga emergency nang may kumpiyansa at kahusayan.",
    features: [
      {
        title: "AI-Powered na Gabay",
        description: "Kumuha ng matalinong, context-aware na tulong sa mga emergency gamit ang aming advanced na AI system.",
      },
      {
        title: "Real-Time na Response",
        description: "Tumanggap ng agarang suporta at mga tagubilin kapag pinaka-kailangan mo ito.",
  },
  {
        title: "Emergency Services Integration",
        description: "Walang kahirap-hirap na kumonekta sa mga emergency service at healthcare provider.",
      },
      {
        title: "Privacy-Focused",
        description: "Ang iyong data ay naka-encrypt at protektado ng enterprise-grade security.",
      },
      {
        title: "Cross-Platform",
        description: "I-access ang RightNowAid sa anumang device, kahit saan, kahit kailan.",
      },
      {
        title: "Lightning Fast",
        description: "Makaranas ng sub-second na response time para sa kritikal na impormasyon.",
      },
    ],
  },
  KO: {
    title: "강력한 비상 대응 기능",
    subtitle: "비상 상황을 자신감과 효율성으로 처리하는 데 필요한 모든 것.",
    features: [
      {
        title: "AI 기반 가이드",
        description: "고급 AI 시스템으로 비상 상황에서 지능적이고 상황 인식이 가능한 지원을 받으세요.",
      },
      {
        title: "실시간 대응",
        description: "가장 필요할 때 즉각적인 지원과 지침을 받으세요.",
      },
      {
        title: "비상 서비스 통합",
        description: "비상 서비스 및 의료 서비스 제공자와 원활하게 연결됩니다.",
      },
      {
        title: "개인정보 보호 중심",
        description: "귀하의 데이터는 기업급 보안으로 암호화되고 보호됩니다.",
      },
      {
        title: "크로스 플랫폼",
        description: "어디서나, 언제든지, 어떤 기기에서든 RightNowAid에 접근하세요.",
      },
      {
        title: "번개처럼 빠른 속도",
        description: "중요 정보에 대해 1초 미만의 응답 시간을 경험하세요.",
      },
    ],
  },
  AR: {
    title: "ميزات قوية للاستجابة للطوارئ",
    subtitle: "كل ما تحتاجه للتعامل مع حالات الطوارئ بثقة وكفاءة.",
    features: [
      {
        title: "توجيه مدعوم بالذكاء الاصطناعي",
        description: "احصل على مساعدة ذكية وواعية بالسياق أثناء حالات الطوارئ مع نظام الذكاء الاصطناعي المتقدم لدينا.",
      },
      {
        title: "استجابة فورية",
        description: "احصل على الدعم والتعليمات الفورية عندما تحتاجها أكثر.",
      },
      {
        title: "تكامل خدمات الطوارئ",
        description: "تواصل بسلاسة مع خدمات الطوارئ ومقدمي الرعاية الصحية.",
      },
      {
        title: "مركز على الخصوصية",
        description: "بياناتك مشفرة ومحمية بأمان على مستوى المؤسسات.",
      },
      {
        title: "متعدد المنصات",
        description: "الوصول إلى RightNowAid على أي جهاز، في أي مكان، في أي وقت.",
      },
      {
        title: "سريع كالبرق",
        description: "تجربة أوقات استجابة أقل من ثانية للمعلومات الحرجة.",
  },
    ],
  },
};

const icons = [
  <Brain className="h-6 w-6" />,
  <Clock className="h-6 w-6" />,
  <Heart className="h-6 w-6" />,
  <Shield className="h-6 w-6" />,
  <Smartphone className="h-6 w-6" />,
  <Zap className="h-6 w-6" />,
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
};

export const Features = () => {
  const { selectedLanguage } = useLanguageStore();
  const t = translations[selectedLanguage];

  return (
    <section className="relative py-16 sm:py-24">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-2xl text-center">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground"
          >
            {t.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="mt-3 sm:mt-4 text-base sm:text-lg text-muted-foreground"
          >
            {t.subtitle}
          </motion.p>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mt-12 sm:mt-16 grid gap-4 sm:gap-6 md:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
        >
          {t.features.map((feature, index) => (
            <motion.div
              key={feature.title}
              variants={itemVariants}
              className="group relative rounded-xl border border-border bg-card p-4 sm:p-6 shadow-sm transition-all hover:shadow-md"
            >
              <div className="mb-3 sm:mb-4 inline-flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                {icons[index]}
              </div>
              <h3 className="mb-2 text-lg sm:text-xl font-semibold text-foreground">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-muted-foreground">
                {feature.description}
              </p>
              <div className="absolute inset-0 rounded-xl border-2 border-primary/0 transition-colors group-hover:border-primary/20" />
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Background Elements */}
      <div className="absolute inset-0 -z-10 bg-grid-white/[0.02] bg-[size:20px_20px]" />
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-background via-background/80 to-transparent" />
    </section>
  );
}; 